export default "__VITE_ASSET__hLmp0CGv__"